/**************************************************************************
 * Created on Tue Feb 11 2026
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http://go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import { Navigate, Route, Routes } from "react-router-dom";
import MainLayout from "../modules/layout/main-layout";
import GuestLayoutSide from "../modules/layout/user-layout/user-layout-side/guest-layout-side";
import DSSLoader from "../ui/building-blocks/atoms/dss-loader/dss-loader";
import React, { Suspense } from "react";

const OverviewPage = React.lazy(() => import("../modules/inds-pre-login-screen/pages/overview-page"));
const ProductAndServices = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/product-n-services"));
const CustomerSupport = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/customer-support"));
const OnlineHelp = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/online-help"));
const QualityDocuments = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/quality-documents"));
const ToolsTechInfo = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/tools-n-tech-info"));
const NewsEvents = React.lazy(() => import("../modules/inds-pre-login-screen/component/support/news-events"));
const AlertsAndNotices = React.lazy(() => import("../modules/inds-pre-login-screen/component/flight-info/alerts-and-notices"));
const EGPWSterDbSearch = React.lazy(() => import("../modules/inds-pre-login-screen/component/flight-info/egpws-terdb-search"));
const LatestAllUpdates = React.lazy(() => import("../modules/inds-pre-login-screen/component/overview/event-sections/latest-update/latest-all-updates").then(module => ({ default: module.LatestAllUpdates })));
const DataOrMediaType = React.lazy(() => import("../modules/inds-pre-login-screen/component/flight-info/database-mediatype/database-mediatype").then(module => ({ default: module.DataOrMediaType })));
const DownloadModule = React.lazy(() => import("../modules/download/route"));

const GuestRouter = () => {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <MainLayout>
            <GuestLayoutSide />
          </MainLayout>
        }
      >
        <Route
          path="/"
          element={<Navigate to="overview" />}
        />
        <Route
          path={`overview/*`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <OverviewPage />
            </Suspense>
          }
        />
        <Route
          path={`overview/allUpdates`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <LatestAllUpdates />
            </Suspense>
          }
        />
        <Route
          path={`/support/*`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <ProductAndServices />
            </Suspense>
          }
        />
        <Route
          path={`/support/customerSupport`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <CustomerSupport />
            </Suspense>
          }
        />
        <Route
          path={`/support/onlineHelp`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <OnlineHelp />
            </Suspense>
          }
        />
        <Route
          path={`/support/qualityDocuments`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <QualityDocuments />
            </Suspense>
          }
        />
        <Route
          path={`/support/toolsInfo`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <ToolsTechInfo />
            </Suspense>
          }
        />
        <Route
          path={`/support/newsEvents`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <NewsEvents />
            </Suspense>
          }
        />
        <Route
          path={`/database/*`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <DownloadModule />
            </Suspense>
          }
        />
        <Route
          path={`/flight-info/*`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <AlertsAndNotices />
            </Suspense>
          }
        />
        <Route
          path={`/flight-info/egpws-search`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <EGPWSterDbSearch />
            </Suspense>
          }
        />
        <Route
          path={`/flight-info/database-mediatype`}
          element={
            <Suspense fallback={<DSSLoader id={""} />}>
              <DataOrMediaType />
            </Suspense>
          }
        />
      </Route>
    </Routes>
  );
};

export default GuestRouter;
